import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="border-t border-border/50 bg-card/30">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <Sparkles className="h-6 w-6 text-primary" />
              <span className="text-lg font-heading font-bold text-gradient">
                GenCNX
              </span>
            </Link>
            <p className="text-muted-foreground text-sm max-w-sm">
              {t("สร้างภาพ วิดีโอ และเพลง AI ที่สวยงามด้วยคลิกเดียว ขับเคลื่อนด้วยเทคโนโลยี AI ล้ำสมัย", "Create stunning AI-generated photos, videos, and music with just a few clicks. Powered by cutting-edge AI technology.")}
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-heading font-semibold mb-4">{t("ผลิตภัณฑ์", "Product")}</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/generate" className="text-muted-foreground hover:text-primary transition-colors">
                  {t("สร้าง", "Generate")}
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-muted-foreground hover:text-primary transition-colors">
                  {t("ราคา", "Pricing")}
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="text-muted-foreground hover:text-primary transition-colors">
                  {t("แดชบอร์ด", "Dashboard")}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold mb-4">{t("ช่วยเหลือ", "Support")}</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/faq" className="text-muted-foreground hover:text-primary transition-colors">
                  {t("ศูนย์ช่วยเหลือ", "Help Center")}
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-muted-foreground hover:text-primary transition-colors">
                  {t("ข้อกำหนดการใช้งาน", "Terms of Service")}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-muted-foreground hover:text-primary transition-colors">
                  {t("นโยบายความเป็นส่วนตัว", "Privacy Policy")}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border/50 text-center text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} GenCNX Platform. {t("สงวนลิขสิทธิ์", "All rights reserved.")}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
